import { BaseElement, ClickElement } from './base-element';
import { ElementType } from './element-type';

export class List extends BaseElement {
  listRows: ListRow[] = [];
  allowFilter: boolean | null = null;

  constructor() {
    super();
    this.elementType = ElementType.list;
  }
}

export class ListRow extends ClickElement {
  constructor() {
    super();
  }

  value1: string | null = null;
  value2: string | null = null;
  value3: string | null = null;
  right: string | null = null;
}
